import { Controller } from "@hotwired/stimulus";
import { getScoreFunctionPreservingOrderInSearch, selectize } from "../selectizeHelper";

export default class CreateOrEditController extends Controller {
    static targets = [
        "country"
    ];

    readonly countryTarget!: HTMLElement;

    connect() {
        selectize($("select"), {
            score: getScoreFunctionPreservingOrderInSearch
        });

        this.disableChromeAutofillForCountry();
    }

    disableChromeAutofillForCountry() {
        // Chrome hack - Chrome auto-fills country and ignores autocomplete="off", so it must be set to autocomplete="chrome-off" :(
        const countrySelectizedInputId = `${$(this.countryTarget).attr("id")}-selectized`;
        $(`#${countrySelectizedInputId}`).attr("autocomplete", "chrome-off");
    }    
}
